import * as React from 'react';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import User from 'src/entities/User';
import { closeModal, CloseModal, openModal, OpenModal } from 'src/actions/modal';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Investment from 'src/entities/Investment';
import {
  setInvestmentData,
  SetInvestmentDataAction
} from 'src/actions/investment/set-data/SetInvestmentData.actions';
import {
  getIndexJuridicalPersons,
  GetIndexJuridicalPersonsAction
} from 'src/actions/juridical-person/index/GetIndexJuridicalPersons.actions';
import Person from 'src/entities/Person';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import { getPhysicalPerson, GetPhysicalPersonAction, }
  from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import { GetUserAction, getUser } from 'src/actions/user/get/GetUser.actions';
import { setActiveProfile, SetActiveProfileAction } from 'src/actions/active-profile/set/SetActiveProfile.actions';
import ChangeActiveProfileComponent
  , { ChangeActiveProfileComponentProps }
  from 'src/modules/modals/investment-funnel/change-profile/ChangeActiveProfile.component';

interface StateProps {
  user?: User;
  physicalPerson?: PhysicalPerson;
  juridicalPersons: JuridicalPerson[];
  investment?: Investment;
  loggedUserData?: number;
  activeProfile?: Person;
  numOfModals: number;
}

interface State {
  person?: Person;
}

interface DispatchProps {
  getIndexJuridicalPersons(userId: number): Promise<GetIndexJuridicalPersonsAction>;
  getPhysicalPerson(physicalPersonId: number): Promise<GetPhysicalPersonAction>;
  setInvestmentData(investment: Investment): SetInvestmentDataAction;
  openModal(component: JSX.Element): void;
  closeModal(): void;
  getUser(loggedUserData: number): Promise<GetUserAction>;
  setActiveProfile(person: Person): SetActiveProfileAction;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  handleBackButton?: () => void;
}

class ChangeActiveProfileContainer extends React.Component<Props, State> {

  public componentWillMount(): void {
    this.setState({ person: undefined });
    if (this.props.user) {
      this.props.getIndexJuridicalPersons(this.props.user.id);
      this.props.getPhysicalPerson(this.props.user!.physicalPersonId).then(() => {
        this.setState ({
          person: this.props.physicalPerson
        });
      });
    } else {
      this.props.getUser(this.props.loggedUserData!).then(() => {
        this.props.getIndexJuridicalPersons(this.props.user!.id);
        this.props.getPhysicalPerson(this.props.user!.physicalPersonId).then(() => {
          this.setState ({
            person: this.props.physicalPerson
          });
        });
      });
    }
  }

  public render(): React.ReactNode {
    return ((this.state.person && this.props.juridicalPersons) ?
      <ChangeActiveProfileComponent {...this.getComponentProps()} /> : null
    );
  }

  private handleJuridicalClick(index?: number): void {
    if (index !== undefined) {
      this.props.setActiveProfile(this.props.juridicalPersons[index]);
    } else {
      this.props.setActiveProfile(this.state.person!);
    }
    if (this.props.numOfModals > 1) {
      this.props.closeModal();
    } else {
      this.props.modalRef!.modal('hide');
    }

  }

  private getComponentProps(): ChangeActiveProfileComponentProps {
    return {
      physicalPerson: this.state.person!,
      juridicalPersons: this.props.juridicalPersons,
      investment: this.props.investment!,
      activeProfile: this.props.activeProfile!,
      defaultProfile: this.props.user!.defaultProfile,
      handleClick: (index?: number) => this.handleJuridicalClick(index),
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getIndexJuridicalPersons: (userId: number): Promise<GetIndexJuridicalPersonsAction> => (
      dispatch(getIndexJuridicalPersons(userId))
    ),
    getPhysicalPerson: (physicalPersonId: number): Promise<GetPhysicalPersonAction> => (
      dispatch(getPhysicalPerson(physicalPersonId))
    ),
    setInvestmentData: (investment: Investment): SetInvestmentDataAction => (
      dispatch(setInvestmentData(investment))
    ),
    openModal: (component: JSX.Element): OpenModal => (
      dispatch(openModal(component))
    ),
    getUser: (userId: number): Promise<GetUserAction> => dispatch(getUser(userId)),
    closeModal: (): CloseModal => (
      dispatch(closeModal())
    ),
    setActiveProfile: (person: Person): SetActiveProfileAction => (
      dispatch(setActiveProfile(person))
    )
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
    user: state.getUser.user || undefined,
    physicalPerson: state.getPhysicalPerson.physicalPerson || undefined,
    activeProfile: state.getUser.activeProfile || undefined,
    juridicalPersons: state.getIndexJuridicalPersons.juridicalPersons,
    investment: state.setInvestmentData.investment || undefined,
    loggedUserData: state.authentication.loggedUserData || undefined,
    numOfModals: state.activeModals.modalHistory ? state.activeModals.modalHistory.length : 0
  });

export default connect(mapStateToProps, mapDispatchToProps)(ChangeActiveProfileContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/change-profile/ChangeActiveProfile.container.tsx